import axiosHttp from "services/axiosHttp";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PermissionManager from "utils/class/PermissionManager";
import { USER } from "constants/AuthConstant";

//action — pass `{ silent: true }` for background refresh (no loading spinner)
export const fetchDiscountApprovalList = createAsyncThunk("fetchDiscountApprovalList", async (arg, { rejectWithValue }) => {
	try {
		const user_channel = PermissionManager.getItem(USER)?.user.user_channel[0].channel_uuid;
		let url = `discount-request/approval/pending?channel_id=${user_channel}`;
		if (arg?.date_filter) url += `&date_filter=${arg.date_filter}`;
		const response = await axiosHttp.get(url);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching detail");
	}
});

export const fetchDiscountApprovedList = createAsyncThunk("fetchDiscountApprovedList", async (_, { rejectWithValue }) => {
	try {
		const user_channel = PermissionManager.getItem(USER)?.user.user_channel[0].channel_uuid;
		const response = await axiosHttp.get(`discount-request/approval/approved?channel_id=${user_channel}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching approved requests");
	}
});

const DiscountApprovalListSlice = createSlice({
	name: "DiscountApprovalListSlice",
	initialState: {
		pending: {
			isLoading: false,
			data: null,
			error: null,
		},
		approved: {
			isLoading: false,
			data: null,
			error: null,
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDiscountApprovalList.pending, (state, action) => {
			const silent = Boolean(action.meta.arg && typeof action.meta.arg === "object" && action.meta.arg.silent);
			if (!silent) {
				state.pending.isLoading = true;
			}
			state.pending.error = null;
		});

		builder.addCase(fetchDiscountApprovalList.fulfilled, (state, action) => {
			const silent = Boolean(action.meta.arg && typeof action.meta.arg === "object" && action.meta.arg.silent);
			if (!silent) {
				state.pending.isLoading = false;
			}
			state.pending.data = action.payload;
		});

		builder.addCase(fetchDiscountApprovalList.rejected, (state, action) => {
			const silent = Boolean(action.meta.arg && typeof action.meta.arg === "object" && action.meta.arg.silent);
			if (!silent) {
				state.pending.isLoading = false;
				state.pending.error = action.payload || action.error.message || "Unknown error occurred";
			}
		});

		builder.addCase(fetchDiscountApprovedList.pending, (state) => {
			state.approved.isLoading = true;
			state.approved.error = null;
		});

		builder.addCase(fetchDiscountApprovedList.fulfilled, (state, action) => {
			state.approved.isLoading = false;
			state.approved.data = action.payload;
		});

		builder.addCase(fetchDiscountApprovedList.rejected, (state, action) => {
			state.approved.isLoading = false;
			state.approved.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default DiscountApprovalListSlice.reducer;
